import { Injectable } from "@angular/core";
import { RemoteRepositoryInterface } from "../../remote/remote.interface";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { EmployeeRepositoryInterface } from "./employee.interface";
import { EmployeeModel } from "../../entities/employee.model";

@Injectable()
export class EmployeeRepository implements EmployeeRepositoryInterface {

    constructor(private remoteRepository: RemoteRepositoryInterface) {}

    public createEmployee(employee: EmployeeModel): Observable<EmployeeModel> {
        return (
            this.remoteRepository.post("users", employee)
                .pipe(
                    map((item) => new EmployeeModel(item as JSON))
                )
        );
    }

    public editEmployee(id: number, employee: EmployeeModel): Observable<EmployeeModel> {
        return (
            this.remoteRepository.update("users/" + id.toString(), employee)
                .pipe(
                    map((item) => new EmployeeModel(item as JSON))
                )
        );
    }

    public deleteEmployee(id: number) {
        this.remoteRepository.delete("users/" + id.toString());
    }
}
